import React, { Component, useContext, useEffect } from "react";
import { contexData } from "@/store";

function AnswerValidityChren({
  children,
  info,
  answer,
  changeAnswer,
  style: styles,
}) {
  const { infoContex, dispatch } = useContext(contexData); //解构得到属性
   return (
    <div
      id={info.id}
      style={{
        background: info.id == infoContex.highlight ? "#1890ff" : "",
        // border: info.id == infoContex.highlight ? "1px solid red" : "",
        padding: 5,
        display:'flex',
        justifyContent: 'center',
        ...styles,
      }}
    >
      {children}
    </div>
  );
}

export default AnswerValidityChren;
